import Model from '@/models/Model'

export default class ParagraphDYKTModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get title () {
    return this.get('attributes.title') || ''
  }

  get description () {
    return this.get('attributes.description') || ''
  }
}
